module.exports = __webpack_public_path__ + "static/media/wl.cfb0052a.png";